import * as api from '@/components/content/definitionLoader/utils/definitionApi'
import Configuration from '@/configuration'
import moment from 'moment'

/**
 * Traduce un contenido HTML reutilizando el LLM configurado en el backend
 * (endpoint POST /service/{ts}/translation/translate, misma config `llm.*`
 * que el chat del segmentador). La API key ya no viaja al navegador.
 * Mantiene las etiquetas, clases e IDs, traduciendo solo el texto.
 *
 * @param {string} htmlToTranslate - HTML que se desea traducir.
 * @param {string} sourceLang - Idioma de origen (ejemplo: "es_es").
 * @param {string} targetLang - Idioma de destino (ejemplo: "ca_es").
 * @param {string} lang - Idioma actual de la app (para el requestHeader).
 * @returns {Promise<string>} - Promesa que devuelve el HTML traducido.
 */
const translateHTML = (htmlToTranslate, sourceLang, targetLang, lang) =>
  api.call({
    domainEndpoint: Configuration.value('API_SERVICES_URL') + moment().valueOf(),
    url: '/translation/translate',
    token: null,
    version: null,
    method: 'POST',
    lang: lang,
    authorization: window.localStorage.getItem('user-token'),
    data: {
      jsonData: JSON.stringify({
        text: htmlToTranslate,
        sourceLang: sourceLang,
        targetLang: targetLang
      })
    }
  }).then(response => (response && response.translation) ? response.translation : '')

export default translateHTML
